// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"24d3cd25","747":"3548356e","958":"553853a0"}[chunkId] + ".chunk.js";
};